import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  text-align: center;
  padding: 0.75rem 0.75rem 0.75rem 0;

  @media only screen and (max-width: 1200px) and (min-width: 790px) {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    .image-wrapper {
      order: 2;
    }
  }
`

export const ImageWrapper = styled.div`
  max-width: 100%;
  transition: 0.2s ease-in-out;
  width: 120px;
  margin: 0 auto;
  position: relative;
`

export const ImageContent = styled.img`
  width: 7.5rem;
  height: 7.5rem;
`

export const Title = styled.h1`
  color: var(--sl-fg-base);
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  margin-top: 24px;
  margin-bottom: 6px;
  @media only screen and (max-width: 1200px) and (min-width: 790px) {
    margin-top: 0;
  }
`
export const Description = styled.p`
  color: var(--sl-fg-base-soft);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-bottom: 4px;
`
